import { theme } from "config/theme";
import styled from "styled-components";

export const RecapJob = styled("div")`
  height: auto;
  padding-top: 12px;
  display: flex;
`;
export const Checbox = styled("div")`
  flex-grow: 1;
  width: 50px;
  ${theme.breakpoints.down("xs")} {
  }
`;
export const DetailParcel = styled("div")`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  ${theme.breakpoints.down("xs")} {
    gap: 14px;
    margin-top: 3px;
    flex-basis: auto;
  }
`;
export const ActionsParcel = styled("div")`
  display: flex;
  width: 150px;
  padding-right: 19px;
  justify-content: space-between;
  align-items: center;
  ${theme.breakpoints.down("xs")} {
    display: flex;
    width: 100px;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
  }
`;
export const GridInfo = styled("div")`
  display: inherit;
  flex: 1;
  ${theme.breakpoints.down("xs")} {
    width: calc(50% - 14px);
    display: flex;
    flex-basis: auto;
  }
`;
export const GlobalButtons = styled("div")`
display: flex;
justify-content: end;
padding: 8px;
${theme.breakpoints.down("xs")} {
  margin-right: 22px;
  margin-bottom: 27px;
  justify-content: center;
},
`;
export const GlobalsButtonsRecap = styled("div")`
display: flex;
justify-content: end;
padding: 8px;
${theme.breakpoints.down("xs")} {
  margin-right: 80px;
  margin-bottom: 49px;
  justify-content: center;
},
`;
